export const aboutData = {
  brand: {
    title: '关于bb体育',
    subtitle: '致力于打造全球领先的体育娱乐平台',
    description: 'bb体育成立于2018年，是一家专注于在线体育资讯与娱乐服务的综合性平台。我们汇聚了来自全球各地的体育专家、数据分析师和技术工程师，致力于为每一位体育爱好者提供最优质的服务体验。',
    vision: '成为全球最受信赖的在线体育平台',
    mission: '让每一位体育爱好者都能在这里找到属于自己的体育世界',
    values: [
      { title: '诚信为本', description: '我们坚持诚信经营，以透明、公正的原则对待每一位用户，建立了行业领先的信誉体系。' },
      { title: '用户至上', description: '用户的满意是我们最大的追求。我们不断优化产品体验，确保每一位用户都能享受流畅、便捷的服务。' },
      { title: '创新驱动', description: '我们持续投入技术研发，运用大数据、人工智能等前沿技术，为用户提供智能化的体育信息服务。' },
      { title: '合作共赢', description: '我们与全球顶级体育赛事组织、媒体机构保持紧密合作，构建开放共赢的体育生态系统。' },
    ],
  },
  reputation: {
    title: '平台信誉',
    subtitle: '以实力赢得信赖',
    items: [
      { icon: 'ri-shield-star-line', title: '合法合规运营', description: '持有国际认可的正规运营牌照，严格遵守所在国家及地区的法律法规，定期接受第三方审计机构的审查监督。' },
      { icon: 'ri-lock-star-line', title: '顶级安全防护', description: '采用256位SSL加密技术与多重防火墙防护体系，通过ISO 27001信息安全管理体系认证，全方位保障用户数据安全。' },
      { icon: 'ri-customer-service-2-line', title: '优质客户服务', description: '7×24小时全天候在线客服支持，平均响应时间低于30秒，用户问题解决率高达98.5%，深受广大用户好评。' },
      { icon: 'ri-verified-badge-line', title: '行业权威认证', description: '荣获多项国际行业大奖与权威认证，包括"最佳体育平台"、"最受用户信赖品牌"等荣誉称号。' },
      { icon: 'ri-money-dollar-circle-line', title: '资金安全保障', description: '用户资金实行独立托管，与平台运营资金完全分离。提款快速到账，大额支付多重验证，确保每一笔交易安全可靠。' },
      { icon: 'ri-thumb-up-line', title: '良好用户口碑', description: '全球累计注册用户突破2000万，用户满意度评分高达4.8分（满分5分），持续保持行业领先的用户留存率。' },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '我们随时为您服务',
    email: 'service@bbsports.com',
    phone: '400-888-8888',
    wechat: 'bb_sports_official',
    address: '中国上海市浦东新区世纪大道100号',
    workingHours: '7×24小时全天候服务',
  },
};